module.exports = __webpack_public_path__ + "static/flags/AF-77084fc5d5158100f436ba82e7999d72.gif";